import React from 'react';
import { Button, Card, InputField, Paragraph } from 'bumbag';
import { Field, Form, Formik } from 'formik';
import _get from 'lodash/get';
import Loads from 'react-loads';

import { Link as RouterLink, withRouter } from '@medipass/react-core/router';
import validate, { isRequired } from '@medipass/utils/validate-form';
import sdk from '@medipass/web-sdk';

import Page from 'legacy/components/account/layout/Page';
import WithAuthentication from 'legacy/components/WithAuthentication';

import { AUTH_URL_FORCE_LOGIN } from '../../constants';

// @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
const hasTypedDelete = value =>
  value.toLowerCase() !== 'delete' ? 'Please enter DELETE to delete your account' : undefined;

type Props = {
  history: (...args: Array<any>) => any;
};

class DeleteAccount extends React.PureComponent<Props> {
  deleteAccount = async () => {
    const { history } = this.props;

    const accountId = _get(sdk, 'account._id');

    await sdk.accounts.deleteAccount(accountId);
    // @ts-expect-error TS(2339): Property 'push' does not exist on type '(...args: ... Remove this comment to see the full error message
    history.push(AUTH_URL_FORCE_LOGIN);
  };
  render = () => (
    <WithAuthentication>
      <Page minWidthBreakpoint="mobile" title="Delete your account?">
        <Card>
          <p className="font-semibold">Delete your account?</p>
          <Paragraph>
            Are you sure you want to delete your account? <br />
            Once you confirm, all of your account information will be permanently deleted.{' '}
          </Paragraph>
          <Loads load={this.deleteAccount}>
            {/* @ts-expect-error TS(7031): Binding element 'deleteAccount' implicitly has an ... Remove this comment to see the full error message */}
            {({ load: deleteAccount, isLoading }) => (
              <Formik
                initialValues={{
                  confirmDelete: '',
                }}
                onSubmit={deleteAccount}
              >
                {() => (
                  <Form>
                    <Field
                      component={InputField.Formik}
                      label="Type DELETE to confirm"
                      name="confirmDelete"
                      validate={validate(isRequired, hasTypedDelete)}
                    />
                    <Button
                      palette="secondary"
                      marginTop="major-1"
                      isLoading={isLoading}
                      size="medium"
                      width="100%"
                      type="submit"
                    >
                      DELETE ACCOUNT
                    </Button>
                    <Button
                      // @ts-expect-error
                      use={RouterLink}
                      to="/account/members/"
                      palette="secondary"
                      marginTop="major-1"
                      variant="ghost"
                      width="100%"
                    >
                      Cancel
                    </Button>
                  </Form>
                )}
              </Formik>
            )}
          </Loads>
        </Card>
      </Page>
    </WithAuthentication>
  );
}

export default withRouter(DeleteAccount);
